<script lang="ts">
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import * as numeral from 'numeral';
    import Header from './Header.svelte';
    import HeaderThemes from './HeaderThemes.svelte';
    import Footer from './Footer.svelte';
    import FooterThemes from './Footerthemes.svelte';
    import Carousel from 'svelte-carousel';
    import Fa from 'svelte-fa'
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { Splide, SplideSlide } from '@splidejs/svelte-splide';
    import '@splidejs/splide/dist/css/themes/splide-default.min.css';
    import { faWallet,faMoneyBillTransfer,faClockRotateLeft,faHandHoldingDollar,faFutbolBall } from '@fortawesome/free-solid-svg-icons';
    import Device from 'svelte-device-info'
    //import { page } from '$app/stores';


    document.body.scrollIntoView();
    let dataSetting = JSON.parse(window.localStorage.getItem('setting'))
    //console.log(page)
    export let params = {};
    let sid = ""
    let pid = ""
    let gameList
    let gametypeList = []
    let device = 'desktop'
    
    async function getProvider() {
        console.log(pid)
    console.log(sid)
        if(sid=='gamehit'){
            if(dataSetting.gamehit){
                gameList = JSON.parse(dataSetting.gamehit)
            }else{
                gameList =[]
            }
           console.log(gameList)
        }else{
            const res = await fetch(window.localStorage.getItem("apiurl")+"member/getproviderlist", {
                method: 'POST',
                headers:{
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                    'x-api-appid': window.localStorage.getItem("appid")
                },
                body: qs.stringify({
                    tab:sid,
                    platform:pid
                })
            })
            const json = await res.json()
            if (json.statusCode==200) {
                gameList = json.payload
                //console.log(gameList)
            } else {
                gameList = []
                throw new Error(json);
            }
        }
        
    }
    async function getPlatform() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getplatform", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({prefix:pid})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            //gametypeList.unshift("gamehit");
            gametypeList = json.payload
            //console.log(gametypeList)
        } else {

            throw new Error(json);
        }
    }

    async function getGameURL(mgds) {
        
        if(Device.isPhone){
            device = 'mobile'
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/startgame", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                _id:mgds,
                device:device,
                type:"provider"
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            window.location = json.payload.url
            
		} else {
            
            // gameList = []
            throw new Error(json);
		}
        
    }
    let carousel;
    let promise
    $: {

        if (params && params.sid) {
            sid = params.sid
            pid = params.pid
            promise = getProvider()
            getPlatform()
            
        } 
    }
    let optionss = {
    rewind : true,
    perPage: 4,
    autoWidth:true,
    gap    : '.2rem',
  }
</script>
<div class="default-home">
<div class="row pt-2 mb-5" style="background-image: url('{dataSetting.background}'); background-size:cover; background-repeat: no-repeat; background-position: center top;">
    <Header />
    
    <div class="col-12 text-center mt-3">
        <div class="row divs p-0 ">
            {#each gametypeList as prs}
            <div class="col">
                {#if sid==prs}
                <button type="button" class="btn-games active" on:click={() => push('/provider/'+pid+'/'+prs)}>
                    <img decoding="async" src="./assets/icon/{prs}.png" alt="{prs} GMZ" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile">{prs.toUpperCase()}</div>
                    </div>
                </button>
                {:else}
                <button type="button" class="btn-games" on:click={() => push('/provider/'+pid+'/'+prs)}>
                    <img decoding="async" src="./assets/icon/{prs}.png" alt="{prs} GMZ" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile">{prs.toUpperCase()}</div>
                    </div>
                </button>
                {/if}
            </div>
            <!-- <button type="button" class="btn btn-outline-secondary btn-sm btn-gd" >{prs}</button> -->
            {/each}
        </div>        
    </div>
    <div class="col-12 text-center mt-0 mb-1">
        <h6 style="background: linear-gradient(135deg, rgb(0 0 0) 0%, rgb(86 80 80) 50%, rgb(131 120 120) 51%, rgb(54 50 50) 71%, rgb(0 0 0) 100%);
        box-shadow: 5px 5px 10px #000 !important;
        line-height: 30px;
        border-radius: 5px;
        padding: 2px 7px;color:gold;text-transform: uppercase;">{sid}</h6>
    </div>
    <div class="col-12 pb-5" style="min-height: 500px;">
        <div class="row d-flex justify-content-center">
            {#await promise}
            <span class="text-white">Loading...</span>
            {:then number}
            {#each gameList as prs}
            {#if prs.active=='O'}
            <div class="col-4 text-center mb-1 pointer" style="position:relative;">
                <a href="#/gamelist/{prs._id}" target="_blank" style="text-decoration: none;">
                    <img src="https://img.gmgauto.one/gameswebp/{prs.platform}/{prs.provider}.webp" class="img-fluid" alt="{prs.provider}" style="border-radius: 10px;"><br />
                    <span class="text-white text-sm"><b>{prs.providerName}</b></span>
                </a>
                
            </div>
            {:else}
            <div class="col-4 text-center mb-1 pointer" style="position:relative;">
                <a href="javascript:;" target="_blank" style="text-decoration: none;">
                    <img src="https://img.gmgauto.one/gameswebp/{prs.platform}/{prs.provider}.webp" class="img-fluid" alt="{prs.provider}" style="border-radius: 10px;"><br />
                    <span class="text-white text-sm"><b>{prs.providerName}</b></span>
                </a>
                <div style="background-color: black;position:absolute;width:100%;height:100%;opacity:0.5;top:0px;border-redius:10px;width:80%;color:white;" class="pt-4">ติด Promotion ไม่สามารถเล่นได้</div>
            </div>
            {/if}
            {/each}
            {/await}
        </div>
    </div>
</div>
<Footer />
</div>
<div class="themes-home" style="display: none;">
    <div class="row mb-3">
        <HeaderThemes/>
    </div>
    <div class="col-12 text-center mt-0 blog-providers {pid} blog-darkred-h1">
        <div class="row divs p-0 ">
            
            {#each gametypeList as prs}
            <div class="col">
                {#if sid==prs}
                <button type="button" class="btn-games active" on:click={() => push('/provider/'+pid+'/'+prs)}>
                    <img decoding="async" src="./assets/icon/{prs}.png" alt="{prs} GMZ" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile">{prs.toUpperCase()}</div>
                    </div>
                </button>
                {:else}
                <button type="button" class="btn-games" on:click={() => push('/provider/'+pid+'/'+prs)}>
                    <img decoding="async" src="./assets/icon/{prs}.png" alt="{prs} GMZ" class="img-fluid -ic-menu entered lazyloaded">
                    <div class="-text-provider-wrapper">
                        <div class="-text-nav-menu -title-mobile">{prs.toUpperCase()}</div>
                    </div>
                </button>
                {/if}
            </div>
            {/each}
        </div>        
    </div>
    <div class="col-12 text-center blog-providers mt-0 mb-1 blog-darkred-s1 ps-2 pe-2">
        <h6 class="head-title">{sid}</h6>
    </div>
    <div class="col-12 pb-5 mb-5" style="min-height: 500px;">
        <div class="row d-flex justify-content-center blog-darkred-s2 ps-2 pe-2">
            {#await promise}
            <span class="text-white">Loading...</span>
            {:then number}
            {#each gameList as prs}
            {#if prs.active=='O'}
            <div class="col-4 text-center mb-1 pointer" style="position:relative;">
                <a href="#/gamelist/{prs._id}" target="_blank" style="text-decoration: none;">
                    <img src="https://img.gmgauto.one/gameswebp/{prs.platform}/{prs.provider}.webp" class="img-fluid" alt="{prs.provider}" style="border-radius: 10px;"><br />
                    <span class="text-white text-sm"><b>{prs.providerName}</b></span>
                </a>
                
            </div>
            {:else}
            <div class="col-4 text-center mb-1 pointer" style="position:relative;">
                <a href="javascript:;" target="_blank" style="text-decoration: none;">
                    <img src="https://img.gmgauto.one/gameswebp/{prs.platform}/{prs.provider}.webp" class="img-fluid" alt="{prs.provider}" style="border-radius: 10px;"><br />
                    <span class="text-white text-sm"><b>{prs.providerName}</b></span>
                </a>
                <div style="background-color: black;position:absolute;width:100%;height:100%;opacity:0.5;top:0px;border-redius:10px;width:80%;color:white;" class="pt-4">ติด Promotion ไม่สามารถเล่นได้</div>
            </div>
            {/if}
            {/each}
            {/await}
        </div>
    </div>
</div>
<div class="footer-themes" style="display: none;">
    <FooterThemes />
</div>
<style>
    :global(.splide){
        width: 354px !important;
        padding: 0px !important;
        margin: 0px !important;
    }
    :global(.splide__pagination){
        display: none !important;
    }
    :global(.splide .splide__arrow.splide__arrow--prev){
        position: absolute;
        left: -10px;
        top: 32px;
        width: 15px;
        height: 15px;
        font-size: 0.5rem;
    }
    :global(.splide .splide__arrow.splide__arrow--next){
        position: absolute;
        right: -10px;
        top: 32px;
        width: 15px;
        height: 15px;
        font-size: 0.5rem;
    }
    .btn-gd{
        --bs-btn-padding-y:0.1rem; --bs-btn-padding-x:0.3rem; --bs-btn-font-size:0.6rem;
        font-weight: 300;
    }
    .bg-dk{
        background-color: black;
    }
    .text-sm{
        font-weight: 300;
        font-size: 0.6rem;
    }
    .pointer{
        cursor: pointer;
    }
    .btn-games {
        margin: 0;
        padding: 7px 10px;
        background: linear-gradient(155deg, #424242, #101010);
        position: relative;
        box-shadow: 0 5px 10px #000000b0;
        border-radius: 10px;
        margin-bottom: 10px;
        cursor: pointer;
        transition: all .3s;
        font-size: 16px;
        position: relative;
        color: #FFF;
        width: 75px !important;
        border: 0px;
    }
    .row.divs .col {
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
    .btn-games img {
        max-width: 35px !important;
    }
    .btn-games .-title-mobile {
        font-size: 10px;
    }
    .btn-games.active, .btn-games:hover {
        background: linear-gradient(181deg,#ffd34e,#794909);
    }
</style>